import React from 'react';
import {connect} from 'react-redux'

class MultiLangText extends React.Component {


    constructor(props){
      super()
      this.state = {
        currentLanguage: 'en',
      }
    }


    compontentWillMount(){
        // TODO: Pick language

    }


    render(){

      let currentText ='';
      let currentLanguage = this.props.currentLanguage.data;


        //console.log();

        //((typeof this.props.text)==='object')?

            (this.props.text[currentLanguage])?
               currentText = this.props.text[currentLanguage]
            : (this.props.text['en'])?
               currentText = this.props.text['en']
             :  null

        //: null

      //console.log("MultiLangText",this.props);
      //console.log('currentText',currentText);

      if(!currentText){
        currentText = ''
      }


        return(<span className={this.props.className} lang={currentLanguage} dangerouslySetInnerHTML={{__html:currentText}} />)

    }



}
const mapStatesToProps = (state)=>{

      //console.log("State",state);
      const currentLanguage = state.KastnerStore.currentLanguage
  return {
    currentLanguage
  }
}


export default connect(mapStatesToProps)(MultiLangText);



// WEBPACK FOOTER //
// ./src/modules/multilang/MultiLangText.js